export default "__VITE_ASSET__D_33vnB4__"